<div class="payment-info-container view-body">
  <ul class="nav secondary-tabs" *ngIf="patientPaymentInfo">
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'general-settings'" data-toggle="tab"
        (click)="setSelectedTab('general-settings')">General Settings</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="selectedTab === 'caxton-card'" data-toggle="tab"
        (click)="setSelectedTab('caxton-card')">Caxton Card</a>
    </li>
    @if (patientPaymentInfo?.trialCaxtonEnabled && patientPaymentInfo?.subsidiaryLinkedToTrial) {
      <li class="nav-item" [class.invalid]="paymentInfoForm.invalid || invalidForm">
        <a class="nav-link" [class.active]="selectedTab === 'caxton-bank'" data-toggle="tab"
          (click)="setSelectedTab('caxton-bank')">Caxton Bank</a>
      </li>
    }
    <li class="nav-item" *ngIf="patientPaymentInfo?.trialNmibleEnabled">
      <a class="nav-link" [ngClass]="{'active': selectedTab === 'nmible-card'}" data-toggle="tab"
        (click)="setSelectedTab('nmible-card')">Nmible Card</a>
    </li>
    <li class="nav-item" *ngIf="patientPaymentInfo?.trialNmibleEnabled">
      <a class="nav-link" [ngClass]="{'active': selectedTab === 'nmible-bank'}" data-toggle="tab"
        (click)="setSelectedTab('nmible-bank')">Nmible Bank</a>
    </li>
  </ul>
  <form [formGroup]="paymentInfoForm" [hidden]="!formInitialized">
    <div class="container">

      <app-payment-info-general-settings #paymentInfoGeneralSettings [hidden]="selectedTab !== 'general-settings'"
        [trialCaxtonEnabled]="trialCaxtonEnabled" [paymentInfoForm]="paymentInfoForm">
      </app-payment-info-general-settings>

      <app-payment-info-caxton-card *ngIf="selectedTab === 'caxton-card'" [trialId]="trialId"
        [patientId]="patientTrialId" [patientBasicInfo]="patientBasicInfo" [patientPaymentInfo]="patientPaymentInfo"
        [paymentInfoForm]="paymentInfoForm" (updated)="getFullPatientPaymentInfo()">
      </app-payment-info-caxton-card>

      <app-payment-info-caxton-bank #paymentInfoCaxtonBank *ngIf="selectedTab === 'caxton-bank'" [trialId]="trialId"
        [patientTrialId]="patientTrialId" [bankRequirements]="bankRequirements"
        [previousBeneficiaryIds]="previousBeneficiaryIds" [paymentInfoForm]="paymentInfoForm"
        [patientPaymentInfo]="patientPaymentInfo">
      </app-payment-info-caxton-bank>

      <app-payment-info-nmible-card *ngIf="selectedTab === 'nmible-card'" [patientDetail]="patientPaymentInfo"
        [patientTrialId]="patientTrialId"></app-payment-info-nmible-card>

      <app-payment-info-nmible-bank *ngIf="selectedTab === 'nmible-bank'" [patientDetail]="patientPaymentInfo"
        [patientTrialId]="patientTrialId"></app-payment-info-nmible-bank>

      <div class="col-md-12" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
        <div class="payment-info-buttons">
          <button class="btn btn-secondary" [disabled]="!updateBeneficiary" (click)="cancel()">Cancel</button>
          <button type="submit" class="btn btn-primary" (click)="updatePatient()"
            [disabled]="paymentInfoForm.invalid || !paymentInfoForm.dirty || invalidForm">
            <span *ngIf="isFormProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!isFormProcessing">Save</span>
          </button>
        </div>
      </div>

    </div>
  </form>
</div>

<app-beneficiaries-list-modal #beneficiariesListModal
  (beneficiaryUpdated)="updateBeneficiaryId($event)"></app-beneficiaries-list-modal>
